import { icons, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var identificationTypeView = [
    {
        active: false,
        icon: {
            icon: icons.List,
        },
        id: "1",
        name: "List",
    },
    {
        active: true,
        icon: {
            icon: icons.GridView,
        },
        id: "2",
        name: "GridView",
    },
];
export var buttonActionOptions = [
    {
        icons: icons.Menu,
        id: "1",
        name: "editar",
    },
    {
        icons: icons.Menu,
        id: "2",
        name: "eliminar",
    }
];
